import { useHistory, useLocation } from 'react-router-dom';
import { Button } from 'shared/ui/Button';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';
import { EDIT_CAMPAIGN_PAGE_KEY, EDIT_CAMPAIGN_MODAL_PAGES } from 'entities/campaign';

export function IncreaseBudgetBtn() {
  const history = useHistory();
  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const handleOnIncreaseBudgetBtnClick = () => {
    query.delete(EDIT_CAMPAIGN_PAGE_KEY);
    query.append(EDIT_CAMPAIGN_PAGE_KEY, EDIT_CAMPAIGN_MODAL_PAGES.weekly_budget);
    history.push({ search: query.toString() });
  };

  return (
    <Button
      className="mt-4"
      type="button"
      onClick={handleOnIncreaseBudgetBtnClick}
      size="medium"
      {...getDataAutoTestAttributes(['button-increase-budget'])}
    >
      Increase budget
    </Button>
  );
}
